
import { jwtDecode } from "jwt-decode";
export const getModuleAccess = () => {
  let moduleAccess = localStorage.getItem("moduleAccess");
  try {
    const decoded = jwtDecode(moduleAccess, '3BA1BB72EF2D8B8BBBB7BA83F5E27');
    return decoded
  } catch (error) {
  }
};

export const getValueByKey = (key) => {
  return localStorage.getItem(key);
};
export const setValueByKey = (key, value) => {
  return localStorage.setItem(key, value);
}
export const removeValueByKey = (key) => {
  return localStorage.removeItem(key);
}
export const getUserName = () => {
  return localStorage.getItem("fullName");
};
export const removeLoggedInUserDetails = () => {
  localStorage.removeItem("email");
  localStorage.removeItem("user");
  localStorage.removeItem("roleId");
  localStorage.removeItem("AssignPromoCopy");
  localStorage.removeItem("adminAccessToken");
  localStorage.removeItem("fullName");
};
export const removeLoggedInMemberDetails = () => {
  localStorage.removeItem("storeNameRegular");
  localStorage.removeItem("phoneNumber");
  localStorage.removeItem("accountName");
  localStorage.removeItem("memberEmail");
  localStorage.removeItem("firstName");
  localStorage.removeItem("lastName");
  localStorage.removeItem("memberAccessToken");
  localStorage.removeItem("hraMemberId");
  localStorage.removeItem("moduleAccess");
  localStorage.removeItem("lastSync");
  localStorage.removeItem("vendorAccess");
};

export const removeLoggedInVendorDetails = () => {
  localStorage.removeItem("vendorAccessToken");
  localStorage.removeItem("vendorUserId");
  localStorage.removeItem("vendorId");
  localStorage.removeItem("vendorContactName");
  localStorage.removeItem("vendorEmail");
  localStorage.removeItem("vendorRoleId");
  localStorage.removeItem("vendorLogo");
};

/* The permissions this vendor login holds on the vendor it is signed in to.
 * vendor_user_access.role_id is a comma separated string ("1,3,5"), stored as
 * it came at login - see VENDOR_USER_ROLES in constant/commonConstants.js. */
export const getVendorRoleIds = () =>
  String(localStorage.getItem("vendorRoleId") || "")
    .split(",")
    .map((roleId) => roleId.trim())
    .filter(Boolean);

/* Whether the signed in vendor user holds a permission. The server checks the
 * same thing on every endpoint that needs it - this only decides whether the
 * button is worth showing, never whether the action is allowed. */
export const vendorHasRole = (roleId) =>
  getVendorRoleIds().includes(String(roleId));

/* True only when a vendor token is present and its exp is still in the future.
 * The token is a HS512 JWT issued with expiresIn 24h. */
export const isVendorLoggedIn = () => {
  const token = localStorage.getItem("vendorAccessToken");
  if (!token) {
    return false;
  }
  try {
    const { exp } = jwtDecode(token);
    return !!exp && exp * 1000 > Date.now();
  } catch (error) {
    return false;
  }
};

/* True only when a member token is present and its exp is still in the future.
 * Same 24h HS512 token the admin and vendor logins issue. */
export const isMemberLoggedIn = () => {
  const token = localStorage.getItem("memberAccessToken");
  if (!token) {
    return false;
  }
  try {
    const { exp } = jwtDecode(token);
    return !!exp && exp * 1000 > Date.now();
  } catch (error) {
    return false;
  }
};

export const setLoginUserData = (data) => {
  localStorage.setItem("email", JSON.stringify(data.data.user.email));
  localStorage.setItem("user", data.data.user.userId);
  localStorage.setItem("lastSync", data.data.user?.storeLastSync?.createdDate);
  localStorage.setItem("roleId", JSON.stringify(data.data.user.roleId));
  localStorage.setItem("adminAccessToken", data?.data?.accessToken);
  localStorage.setItem("favouriteMenu", data?.data?.user?.favouriteMenu);
  localStorage.setItem("fullName", data?.data?.user?.fullName);
  localStorage.setItem("vendorAccess", data?.data?.user?.vendorAccess);
  localStorage.setItem("agreements", JSON.stringify(data?.data?.agreements));
  localStorage.setItem("moduleAccess", data?.data?.moduleAccess);
};
export const setLoginMemberData = (data) => {
  localStorage.setItem("storeNameRegular", data?.data?.user?.storeNameRegular);
  localStorage.setItem("phoneNumber", data?.data?.user?.phoneNumber);
  localStorage.setItem("accountName", data?.data?.user?.accountName);
  localStorage.setItem("memberEmail", JSON.stringify(data.data.user.email));
  localStorage.setItem("firstName", JSON.stringify(data.data.user.firstName));
  localStorage.setItem("lastName", JSON.stringify(data.data.user.lastName));
  localStorage.setItem("memberAccessToken", data?.data?.accessToken && data.data.accessToken);
  localStorage.setItem("mailingStreetAddress", data.data.user.mailingStreetAddress + ", " + data.data.user.city + ", " + data.data.user.state + ", " + data.data.user.mailingZip);
  localStorage.setItem("hraMemberId", JSON.stringify(data.data.user.hraMemberId));
  localStorage.setItem("parentHraMemberId", JSON.stringify(data.data.user.hraMemberId));

};
/* Shape matches the vendor_portal POST /vendor/login response */
export const setLoginVendorData = (data) => {
  localStorage.setItem("vendorAccessToken", data?.data?.token);
  localStorage.setItem("vendorUserId", data?.data?.vendorUser?.vendorUserId);
  localStorage.setItem("vendorId", data?.data?.vendorUser?.vendorId);
  localStorage.setItem("vendorContactName", data?.data?.vendorUser?.contactName);
  localStorage.setItem("vendorEmail", data?.data?.vendorUser?.email);
  localStorage.setItem("vendorRoleId", data?.data?.vendorUser?.roleId);
  /* may be null when the vendor has no logo uploaded - keep the key clear
   * instead of storing the string "null" */
  if (data?.data?.vendorUser?.vendorLogo) {
    localStorage.setItem("vendorLogo", data.data.vendorUser.vendorLogo);
  } else {
    localStorage.removeItem("vendorLogo");
  }
};

export function getFileNameFromUrl(url) {
  const segments = url?.split("/");
  let fileName = segments?.pop();
  fileName = fileName?.replace(/%/g, "");
  return fileName;
}

export function removeZohoToken() {
  localStorage.removeItem("zohoTokenTime");
  localStorage.removeItem("zohoToken");
}

